import React from "react"
import {FieldViewProps} from "../../../render/view";


export default function FieldPopover_View(props: FieldViewProps) {

    const value = _.get(props.model, props.field.fieldId, null)

    const valueClasses = Classes("ui5-txt-default", "fl-ac", props.className)

    return (
        <div className={valueClasses} onClick={props.onClick}>
            {_.get(props.field.components, 'ValueIcon', false)}
            <span className="txt-truncate">{value}</span>
        </div>
    )

}